import { lazyTool } from "../lazy";
import type { ToolDefinition } from "../types";

export const dataTools: ToolDefinition[] = [
  {
    id: "json-formatter",
    name: "JSON Formatter & Validator",
    description: "Pretty-print, minify, sort, and validate JSON with clear line and column errors.",
    category: "data",
    keywords: ["json", "format", "beautify", "minify", "validate", "pretty print", "lint"],
    component: lazyTool(() => import("./json-formatter")),
    featured: true,
  },
  {
    id: "yaml-json",
    name: "YAML ↔ JSON",
    description: "Convert YAML to JSON and back, including multi-document streams.",
    category: "data",
    keywords: ["yaml", "yml", "json", "convert", "multi document", "config"],
    component: lazyTool(() => import("./yaml-json")),
  },
  {
    id: "csv-json",
    name: "CSV ↔ JSON",
    description: "Convert CSV to JSON and back with RFC 4180 quoting and delimiter options.",
    category: "data",
    keywords: ["csv", "tsv", "json", "convert", "delimiter", "headers", "table"],
    component: lazyTool(() => import("./csv-json")),
  },
  {
    id: "json-to-typescript",
    name: "JSON to TypeScript",
    description: "Infer TypeScript interfaces and type aliases from a JSON sample.",
    category: "data",
    keywords: ["json", "typescript", "interface", "type", "infer", "generate", "types"],
    component: lazyTool(() => import("./json-to-typescript")),
  },
  {
    id: "jsonpath",
    name: "JSONPath Evaluator",
    description: "Evaluate JSONPath expressions and inspect every match with its path.",
    category: "data",
    keywords: ["jsonpath", "json", "query", "filter", "evaluate", "select"],
    component: lazyTool(() => import("./jsonpath")),
  },
  {
    id: "xml-formatter",
    name: "XML Formatter",
    description: "Pretty-print and validate XML with clear parser errors.",
    category: "data",
    keywords: ["xml", "format", "beautify", "validate", "pretty print", "indent"],
    component: lazyTool(() => import("./xml-formatter")),
  },
  {
    id: "xml-json",
    name: "XML ↔ JSON",
    description: "Convert XML to JSON and back with attributes and text conventions.",
    category: "data",
    keywords: ["xml", "json", "convert", "attributes", "text", "mapping"],
    component: lazyTool(() => import("./xml-json")),
  },
  {
    id: "json-schema",
    name: "JSON Schema Generator",
    description: "Infer a draft-07 JSON Schema from a JSON sample, including required fields.",
    category: "data",
    keywords: ["json", "schema", "draft 07", "infer", "generate", "validation"],
    component: lazyTool(() => import("./json-schema")),
  },
  {
    id: "sql-formatter",
    name: "SQL Formatter",
    description: "Format SQL with dialect, keyword case, and indentation controls.",
    category: "data",
    keywords: ["sql", "format", "pretty", "dialect", "keywords", "query"],
    component: lazyTool(() => import("./sql-formatter")),
  },
  {
    id: "graphql-formatter",
    name: "GraphQL Formatter",
    description: "Parse and pretty-print GraphQL operations and schemas with error locations.",
    category: "data",
    keywords: ["graphql", "format", "schema", "query", "mutation", "print", "parse"],
    component: lazyTool(() => import("./graphql-formatter")),
  },
];
